import React, {Component} from 'react';
import {injectIntl} from 'react-intl';

import {Row, Col} from 'react-bootstrap';

import LanguageSelect from 'containers/ui/select/LanguageSelect';
import ResetPasswordFormContainer from 'containers/reset/ResetPasswordFormContainer';

const logoUrl = require('img/equinix_logo.svg');


/** Route to render the The reset passoword container */
class ResetPassword extends Component {

    render() {
        const
            {location: {state}} = this.props,
            nextPathName = state ? state.nextPathname : null;

        return (
            <div>
                <div className="container reset-password-container login-container">
                    <Row>
                        <Col sm={4}>
                            <div className="login-logo">
                                <img alt="logo2" src={logoUrl}/>
                            </div>
                        </Col>
                        <Col sm={6} lg={5}>
                            <LanguageSelect className="pull-right"/>
                            <ResetPasswordFormContainer nextPathname={nextPathName}/>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

export default injectIntl(ResetPassword);



// WEBPACK FOOTER //
// ./src/routes/reset/ResetPassword.jsx